import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DialogDoctorComponent } from '../dialogs/dialog-doctor/dialog-doctor.component';
import { FileHandle } from '../drag-drop.directive';
import { DialogType, MediDialogComponent } from '../medi-dialog/medi-dialog.component';
import { OroService } from '../oroservice';
declare let $: any;

type BehandlerItem = {
    Id: number;
    Name: string;
    Fachrichtung: string;
}

@Component({
    selector: 'app-master-data',
    templateUrl: './master-data.component.html',
    styleUrls: ['./master-data.component.scss'],
    standalone: false
})
export class MasterDataComponent implements OnInit {
    stammdaten: any = {};

    profiltab: number = 0;
    isValid: boolean = false;
    isLoading: boolean = false;

    ProfilBild: FileHandle;
    HasOriginalProfilBild: boolean = false;
    OriginalProfilBild = {};

    datumzukunftgeburtsdatum = false;
    Standort: any = {};

    behandlerColumns: string[] = ['Name', 'Art', 'Edit'];
    behandlerDatasource: BehandlerItem[];

    OldData: string;

    constructor(public oroservice: OroService,
                private _router: Router,
                public dialog: MatDialog,
                private cdref: ChangeDetectorRef,
                private sanitizer: DomSanitizer) { }

    ngOnInit() {
        this.isLoading = true;
        this.oroservice.getKundenInfo().then(
            () => {
                if (!this.oroservice.kundeninfo.IsMaster) {
                    this._router.navigate(['Startseite']);
                }
            }
        );

        this.refresh();
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        const NewData = JSON.stringify(this.stammdaten).replace(/null/g,"\"\"");

        //console.log("OLD: " + this.OldData);
        //console.log("NEW: " + NewData);

        return (this.ProfilBild == null &&  this.OldData.localeCompare(NewData) === 0);
	}

    refresh() {
        this.isLoading = true;
        this.HasOriginalProfilBild = false;
        this.ProfilBild = null;
        this.OriginalProfilBild = {};

        this.oroservice.getStammdaten().then((object) => {
            this.Standort = {};
            this.stammdaten = object;
            this.stammdaten.Behandler = { Id: 0, Sprache: 0 };
            this.Standort = !this.oroservice.isEmptyObject(this.stammdaten.Standorte) && this.stammdaten.Standorte.length > 0 ? this.stammdaten.Standorte[0] : {};
            if (!this.oroservice.isEmptyObject(this.stammdaten.Inhaber)) {
                this.stammdaten.Inhaber.Geburtsdatum = new DatePipe('en-EN').transform(this.oroservice.parseDate(this.stammdaten.Inhaber.Geburtsdatum), 'yyyy-MM-dd');
            }
            this.stammdaten.Geburtsdatum = new DatePipe('en-EN').transform(this.oroservice.parseDate(this.stammdaten.Geburtsdatum), 'yyyy-MM-dd');
            this.stammdaten.KontoLand = 0; // Nur CH Konto

            this.isValid = true;

            if (this.stammdaten.HasProfilbild) {
                this.oroservice.getProfilBild(this.stammdaten.GpId).then((object) => {
                    if (object) {
                        this.HasOriginalProfilBild = true;
                        this.OriginalProfilBild = object;
                    }

                    this.isLoading = false;
                });
            } else {
                this.isLoading = false;
            }

            this.refreshBehandler();

            this.OldData = JSON.stringify(this.stammdaten).replace(/null/g,"\"\"");
        });
    }

    private refreshBehandler() {
        this.behandlerDatasource = [];

        this.oroservice.getKundenInfo().then(
            () => {
                this.oroservice.kundeninfo.Behandler.forEach(element => {
                    let name: string = element.Vorname + " " + element.Name;

                    if (element.Titel) {
                        if (element.Titel === 20) {
                            // 20 = sonstige
                            name = element.TitelSonstige + " " + name;
                        }
                        else {
                            name = this.oroservice.kundeninfo.Titel.find(o => o.Id === element.Titel)?.Name + " " + name;
                        }
                    }

                    let fach: string = this.oroservice.kundeninfo.Fachrichtungen.find(o => o.Id === element.Fachrichtung)?.Name;
                    if (!fach) {
                        fach = "?";
                    }

                    this.behandlerDatasource.push({
                        Id: element.Id,
                        Name: name,
                        Fachrichtung: fach
                    });
                });
            });
    }

    SaveSettings() {
        let formdata = this.getfile();
        const json = JSON.stringify(this.stammdaten);
        console.log(json);
        formdata.append("stammdaten", json);

        this.oroservice.setStammdaten(formdata).then((object) => {
            if (object.status === 500 || object.status === 400) {
                this.oroservice.getKundenInfo().then((o) => {
                    this.refresh();
                });
            }
        });
    }

    openDialog(paramWidth: string, paramTitle: string, paramContent: string, paramYes: string, paramNo: string, paramType: DialogType = DialogType.None): Observable<boolean> {
        const dialogRef = this.dialog.open(MediDialogComponent, {
            width: paramWidth,
            data: { title: paramTitle, content: paramContent, yes: paramYes, no: paramNo, type: paramType }
        });

        return dialogRef.afterClosed();
    }

    getfile() {
        let formData = new FormData();
        if (this.ProfilBild) {
            formData.append('fileItem', this.ProfilBild.file, this.ProfilBild.file.name);
        }

        return formData;
    }

    filesDropped(files: FileHandle[]): void {
        if (files && files.length > 0) {
            let file = files[0];

            if (file.file.name.slice(-3).toUpperCase() === "JPG" || file.file.name.slice(-4).toUpperCase() === "JPEG") {
                if (file.file.size <= 5000000) {
                    // OK
                    this.ProfilBild = file;
                }
                else {
                    this.openDialog("500px", "Achtung", "ErrorSizeFormat", "OK", "", DialogType.Warning);
                }
            }
            else {
                this.openDialog("500px", "Achtung", "ErrorFileFormatJpeg", "OK", "", DialogType.Warning);
            }
        }
    }

    handleFileInput(files: FileList) {
        if (files.length > 0)
        {
            let saneUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(files[0]));
            let fh: FileHandle = {file:files[0], url:saneUrl};
            this.filesDropped([fh]);
        }

    }

    public checkDatumZukunft(date: Date): boolean {
        return date > new Date();
    }

    public clearPicture() {
        this.ProfilBild = null;
    }

    public deletePicture() {
        this.HasOriginalProfilBild = false;
        this.stammdaten.RemoveProfilbild = true;
    }

    public IsNogaValid() : boolean {
        if (!this.stammdaten.NogaCode) {
            return true;
        }

        const re = new RegExp("^[0-9]*$");
        return re.test(this.stammdaten.NogaCode);
    }

    public IsIbanValid(): boolean {
        if (!this.stammdaten.IBAN) {
            return true;
        }

        const iban = this.stammdaten.IBAN.replace(/\s+/g, '').toUpperCase();
        if (!/^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/.test(iban)) {
            return false;
        }

        const rearranged = iban.slice(4) + iban.slice(0, 4);
        let remainder = 0;

        for (const char of rearranged) {
            const chunk = char >= 'A' && char <= 'Z'
                ? (char.charCodeAt(0) - 55).toString()
                : char;

            for (const digit of chunk) {
                remainder = (remainder * 10 + Number(digit)) % 97;
            }
        }

        return remainder === 1;
    }

    public canSubmit(): boolean {
        // Institution
        if (this.stammdaten.IstInstitution) {
            if (!this.IsNogaValid()) {
                return false;
            }

            if (this.stammdaten.Sprache < 1 || !this.stammdaten.Name || this.stammdaten.Rechtsform < 1) {
                return false;
            }

            if (this.oroservice.kundeninfo.HasPraxisart && this.stammdaten.Praxisart < 1) {
                return false;
            }

            if (this.stammdaten.Rechtsform === 1 || this.stammdaten.Rechtsform === 2) {
                if (this.stammdaten.Inhaber.Anrede < 1
                    || this.stammdaten.Inhaber.Sprache < 1 || !this.stammdaten.Inhaber.Vorname || !this.stammdaten.Inhaber.Name) {
                    return false;
                }

                if (!this.stammdaten.Inhaber.Standort.Anschrift
                    || !this.stammdaten.Inhaber.Standort.Hausnummer
                    || this.stammdaten.Inhaber.Standort.Land < 0
                    || !this.stammdaten.Inhaber.Standort.Plz) {
                    return false;
                }

                if (!this.stammdaten.Inhaber.Geburtsdatum) {
                    return false;
                }

                if (this.stammdaten.Inhaber.Geburtsdatum > new Date()) {
                    return false;
                }
            }
        }
        // Person
        else {
            if (this.stammdaten.Sprache < 1 || !this.stammdaten.Vorname || !this.stammdaten.Name) {
                return false;
            }

            if (!this.stammdaten.Geburtsdatum) {
                return false;
            }
        }

        if (!this.Standort.Anschrift || !this.Standort.Hausnummer
                || this.Standort.Land < 0 || !this.Standort.Plz
                || !this.Standort.Ort) {
            return false;
        }

        if (!this.stammdaten.Kontoinhaber || !this.stammdaten.IBAN || (!this.stammdaten.KontoStrasse && !this.stammdaten.KontoHausnummer)
                 || this.stammdaten.KontoPLZ.length !== 4 || !this.stammdaten.KontoOrt || !this.IsIbanValid()) {
            return false;
        }
        return true;
    }

    public NewBehandler(): void {
        const behandler = { Id: -1, Anrede: 0, Fachrichtung: 0, Vorname: '', Name: '', Sprache: 0 };

        const dialogRef = this.dialog.open(DialogDoctorComponent, {
            width: "850px",
            disableClose: true,
            data: { behandler: behandler },
            autoFocus: false
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.refreshBehandler();
            }
        });
    }

    public EditBehandler(item: BehandlerItem) {
        const behandler = this.oroservice.kundeninfo.Behandler.find(o => o.Id === item.Id);

        const dialogRef = this.dialog.open(DialogDoctorComponent, {
            width: "850px",
            disableClose: true,
            data: { behandler: behandler },
            autoFocus: false
        });

        dialogRef.afterClosed().subscribe(result => {
            this.refreshBehandler();
        });
    }

    public DeleteBehandler(item: BehandlerItem) {
        const behandler = this.oroservice.kundeninfo.Behandler.find(o => o.Id === item.Id);

        this.openDialog("500px", "Aufträge.NachfrageBehandlerLoeschen", "Aufträge.NachfrageBehandlerLoeschentext", "OK", "Abbrechen", DialogType.Question).subscribe(result => {
            if (result) {
                this.oroservice.deletebehandler(behandler).then((object) => {
                    this.oroservice.getKundenInfo().then((o) => {
                        this.oroservice.openDialogMessage("Aufträge.FeedbackBehandlerLoescehn");
                        this.refreshBehandler();
                    })
                });
            }
        });
    }
}
